import React from 'react';
import { LogoTrello, useAnalytics, useAnalyticsAttributes } from '../../../components';
import { LogoLink } from './Logo.styles';
export function Logo({ id }) {
    const { sendTrackEvent } = useAnalytics();
    const analyticsAttributes = useAnalyticsAttributes();
    return (React.createElement(LogoLink, { href: "/home", onClick: () => sendTrackEvent('clickedUiHeaderNavLogo', Object.assign(Object.assign({}, analyticsAttributes), { event: 'clicked', eventComponent: 'logo', label: 'Trello logo', uuid: `${id}_logo`, href: '/home' })), "data-uuid": `${id}_logo`, testId: "logo_link" },
        React.createElement(LogoTrello, { height: 22.5, appearance: "blue", id: id })));
}
//# sourceMappingURL=Logo.js.map